import { type Library } from '@air/api/types';
import { HouseIcon, ImagesIcon } from '@air/design-icons';

import { type IconType } from '~/types/icons';

export const GeneralLibrary: Pick<Library, 'title' | 'id'> & { Icon: typeof HouseIcon } = {
  id: 'general',
  title: 'General',
  Icon: HouseIcon,
};

export const DefaultLibraryIcon = ImagesIcon;

export type LibraryWithIcon = Pick<Library, 'title'> & { Icon: IconType };
